// The learner's side of Capability, as the screens word it. What a learner has
// done, and every rule that decides their level, is the backend's
// (GET /v3/member/capability; BE shared/services/capability/rules.ts).

import { LEVEL_ORDER, type CapabilityLevel } from '../../Program/components/learning-lifecycle/teamCapability';

/** An Assessment Roleplay (one attempt), one the learner started to be graded, or an ungraded practice round. */
export type AttemptKind = 'assessment' | 'graded' | 'practice';

export const SELF_INITIATED = 'Self Initiated Roleplay';
/** A learner can start this many graded Roleplays per capability in a week. */
export const GRADED_PER_WEEK = 5;

const LEVEL_TITLE: Record<CapabilityLevel, string> = {
  weak: 'Weak',
  developing: 'Developing',
  capable: 'Capable',
  advanced: 'Advanced'
};

export type LevelDirection = 'up' | 'down' | 'same';

/**
 * How a level moved with the most recent Roleplay: where it was before it,
 * where it is now. Null when there is nothing to compare (not assessed, or the
 * first Roleplay).
 */
export const levelChange = (
  previous: CapabilityLevel | null,
  current: CapabilityLevel | null
): { direction: LevelDirection; text: string } | null => {
  if (!current || !previous) return null;
  const move = LEVEL_ORDER.indexOf(current) - LEVEL_ORDER.indexOf(previous);
  if (move > 0) {
    return {
      direction: 'up',
      text: `Up from ${LEVEL_TITLE[previous]} to ${LEVEL_TITLE[current]} with your most recent Roleplay.`
    };
  }
  if (move < 0) {
    return {
      direction: 'down',
      text: `Down from ${LEVEL_TITLE[previous]} to ${LEVEL_TITLE[current]} with your most recent Roleplay.`
    };
  }
  return { direction: 'same', text: `Stayed at ${LEVEL_TITLE[current]} with your most recent Roleplay.` };
};
